"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dotenv = void 0;
const fs_1 = require("fs");
const is_string_1 = require("./is-string");
const parse = (contents) => {
    const result = {};
    for (const line of contents.toString().split("\n")) {
        const matches = new RegExp(/^([^=:#]+?)[=:](.*)/).exec(line);
        if (!matches) {
            continue;
        }
        const key = matches[1].trim();
        const value = matches[2].replace(/^"(.*)"$/, "$1").trim();
        if (key && value) {
            if (new RegExp(/^\d+$/).test(value)) {
                result[key] = Number(value);
            }
            else if (["true", "false"].includes(value)) {
                result[key] = value === "true";
            }
            else {
                result[key] = value;
            }
        }
    }
    return result;
};
const parseFile = (file) => {
    return parse(fs_1.readFileSync(file).toString());
};
const stringify = (pairs) => {
    const contents = [];
    for (const key of Object.keys(pairs).filter(Boolean)) {
        const value = pairs[key];
        contents.push(is_string_1.isString(value) ? `${key}="${value}"` : `${key}=${value}`);
    }
    return contents.join("\n");
};
exports.dotenv = { parse, parseFile, stringify };
//# sourceMappingURL=dot-env.js.map